import { render, staticRenderFns } from "./goodsChangeApprove.vue?vue&type=template&id=95167e24&scoped=true&"
import script from "./goodsChangeApprove.vue?vue&type=script&lang=js&"
export * from "./goodsChangeApprove.vue?vue&type=script&lang=js&"
import style1 from "./goodsChangeApprove.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95167e24",
  null
  
)

export default component.exports